module.exports = __webpack_public_path__ + "static/media/logo.a9f1cabe.jpg";